var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',_vm._b({ref:"formItem",attrs:{"label-width":_vm.labelWidth,"show-message":_vm.hasMessage,"inline-message":_vm.isMessageInline}},'el-form-item',_vm.trimAttrs(_vm.$attrs),false),[_c('template',{slot:"label"},[_vm._t("label")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }